import React from "react";
import { Button, Container, Jumbotron } from "react-bootstrap";
import "./Banner.css";
const Banner = () => {
  return (
    <Jumbotron className="banner_0 d-flex align-items-center">
      <Container className="p-2 w-100 text-white">
        <h2
          style={{
            margin: "0 86px 0 0",
            fontWeight: "400",
            fontSize: "3rem",
            lineHeight: "1.1",
          }}
        >
          WE ARE HERE TO HELP YOU
        </h2>
        <h5 className="w-100 text-center brand_text my-3">IMPROVE YOURSELF</h5>
        <p className="w-75" style={{ maxWidth: "560px" }}>
          We are here to support you no matter who you are and no matter where
          you're at in your fitness journey. Providing the best equipment and
          the best instructors, we keep you motivated and on track to hit your
          goals.
        </p>
        <p>
          <Button variant="primary">Join Now</Button>
        </p>
      </Container>
    </Jumbotron>
  );
};

export default Banner;
